// src/app/AdminApp.js - Template Marketplace Admin
import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { DataProvider } from '../context/DataContext';
import Header from '../components/Header';

// Admin pages
import Dashboard from './Dashboard';
import Analytics from './Analytics';
import GoogleSheetsSetupWizard from './GoogleSheetsSetupWizard';
import TemplateManager from './TemplateManager';
import AITemplateBuilder from './AITemplateBuilder';

// Keep existing template configurator
import TemplateConfigurator from '../configurator/TemplateConfigurator';

const AdminApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState('dashboard');

  // Update currentPage based on route
  useEffect(() => {
    const path = location.pathname;
    let page = 'dashboard';

    if (path.includes('/app/templates')) {
      page = 'templates';
    } else if (path.includes('/app/ai-builder')) {
      page = 'ai-builder';
    } else if (path.includes('/app/sheets-setup')) {
      page = 'sheets-setup';
    } else if (path.includes('/app/analytics')) {
      page = 'analytics';
    } else if (path.includes('/app/template-config')) {
      page = 'template-config';
    } else if (
      path.includes('/app/dashboard') ||
      path === '/app' ||
      path === '/app/'
    ) {
      page = 'dashboard';
    }

    setCurrentPage(page);
  }, [location.pathname]);

  const handleSetCurrentPage = (page) => {
    setCurrentPage(page);
    navigate(`/app/${page}`);
  };

  return (
    <DataProvider>
      <div className="min-h-screen bg-gray-50">
        <Header
          currentPage={currentPage}
          setCurrentPage={handleSetCurrentPage}
          user={{ name: 'Admin User' }}
        />
        <main>
          <Routes>
            <Route
              path="/"
              element={<Dashboard setCurrentPage={handleSetCurrentPage} />}
            />
            <Route
              path="/dashboard"
              element={<Dashboard setCurrentPage={handleSetCurrentPage} />}
            />
            <Route
              path="/templates"
              element={
                <TemplateManager setCurrentPage={handleSetCurrentPage} />
              }
            />
            <Route
              path="/ai-builder"
              element={
                <AITemplateBuilder setCurrentPage={handleSetCurrentPage} />
              }
            />
            <Route
              path="/sheets-setup"
              element={
                <GoogleSheetsSetupWizard
                  setCurrentPage={handleSetCurrentPage}
                />
              }
            />
            <Route
              path="/analytics"
              element={<Analytics setCurrentPage={handleSetCurrentPage} />}
            />
            <Route
              path="/template-config"
              element={
                <TemplateConfigurator setCurrentPage={handleSetCurrentPage} />
              }
            />
            <Route
              path="*"
              element={<Dashboard setCurrentPage={handleSetCurrentPage} />}
            />
          </Routes>
        </main>
      </div>
    </DataProvider>
  );
};

export default AdminApp;
